export default __webpack_public_path__ + "static/media/elo.eb7df207.png";